import React from 'react'

import { TooltipState } from '../../../hooks/useCursorTooltip.ts'

type CursorTooltipProps = {
  tooltip: TooltipState
  className?: string
}

export const CursorTooltip: React.FC<CursorTooltipProps> = ({
  tooltip,
  className = 'fixed z-50 pointer-events-none rounded-md bg-gray-900 px-2 py-1 text-xs text-white shadow-sm'
}) => {
  if (!tooltip.visible) return null

  return (
    <div style={{ left: tooltip.x, top: tooltip.y }} className={className}>
      {tooltip.text}
    </div>
  )
}
